import { Box, Divider, Grid, Typography } from "@mui/material";
import i18n from "../../i18n-config";
import { CustomButton } from "../../components";
import theme from "../../theme/theme";
import {
  BARA,
  GROUILLEUR,
  SINISTRE,
  TRANSACTIONS,
} from "../../assets/icons";
import { capitalizeFirstLetter } from "../../utils/strings";
import DashboardTopCard from "./components/DashboardTopCard";
import DashboardBottomHead from "./components/DashboardBottomHead";
import DashboardActivityCard from "./components/DashboardActivityCard";
import { useSelector } from "react-redux";
import { RootState } from "../../store/state";
import { useNavigate } from "react-router-dom";

function Dashboard() {
  const offres = useSelector((state: RootState) => Object.values(state.offre));
  const transactions = useSelector((state: RootState) => Object.values(state.transaction));
  const grouilleurs = useSelector((state: RootState) => Object.values(state.grouilleur));
  const sinistres = useSelector((state: RootState) => Object.values(state.sinistre));

  const navigate = useNavigate();

  const goToBara=()=>{
    navigate("/bara");
  }

  return (
    <Box sx={{ height: "100vh", backgroundColor: "#F9F9F9" }} p={3} pt={6}>
      <Grid container spacing={5}>
        <Grid item xs={3}>
          <DashboardTopCard
            title={i18n.t("bara")}
            subTitle={offres.length}
            icon={BARA}
            iconColor="#3597DD"
          />
        </Grid>
        <Grid item xs={3}>
          <DashboardTopCard
            title={i18n.t("grouilleurs")}
            subTitle={grouilleurs.length}
            icon={GROUILLEUR}
            iconColor="#FF8C21"
          />
        </Grid>
        <Grid item xs={3}>
          <DashboardTopCard
            title={i18n.t("sinistres")}
            subTitle={sinistres.length}
            icon={SINISTRE}
            iconColor="#FF1D1D"
          />
        </Grid>
        <Grid item xs={3}>
          <DashboardTopCard
            title={i18n.t("transactions")}
            subTitle={transactions.length}
            icon={TRANSACTIONS}
            iconColor="#2CAE60"
          />
        </Grid>
      </Grid>

      <Grid container spacing={5} mt={2}>
        <Grid item xs={6}>
          <Box sx={{ backgroundColor: "white", borderRadius: 2, p: 2, py: 3, boxShadow: "0px 4px 4px rgba(139, 139, 139, 0.05)", }}>
            <DashboardBottomHead icon={BARA} title={i18n.t('bara_recents')} value="3" />
            {offres.slice(0,7).map((offre:any)=> <>
              <Typography key={offre.id}>{offre.titre}</Typography>
            <Divider sx={{ my: 2 }} />
            </>)}
            <CustomButton
              title={capitalizeFirstLetter(i18n.t("voir_bara"))}
              titleStyle={{ color: theme.colors.white }}
              onClick={goToBara}
            />
          </Box>
        </Grid>
        <Grid item xs={6}>
          <Box sx={{ backgroundColor: "white", borderRadius: 2, p: 2, py: 3, boxShadow: "0px 4px 4px rgba(139, 139, 139, 0.05)", }}>
          <DashboardBottomHead icon={BARA} title={i18n.t('activites')} value="2" />
          <DashboardActivityCard title="Mains d-oeuvre ..." iconColor={theme.colors.primary} />
          <DashboardActivityCard title="Réparateur Auto" iconColor={theme.colors.primary} />
          <DashboardActivityCard title="Femme de ménage" iconColor={theme.colors.dimgray} />
          <DashboardActivityCard title="Maintenancier" iconColor={theme.colors.dimgray} />
          <DashboardActivityCard title="Climaticien" iconColor={'#F2B005'} />
            <CustomButton
              title={capitalizeFirstLetter(i18n.t("voir_plus"))}
              titleStyle={{ color: theme.colors.white }}
            />
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
}

export default Dashboard;
